import { Log, UserManager } from 'oidc-client';

import { Feil } from '../diverse/Feil';
import { installasjon } from '../diverse/installasjon';

export const idportentilbyder = {
	id: 'idporten',
	realm: 'norge.no',
	clientIdNokkel: 'idportenClientId',
	innstillinger: {
		scope: 'openid svvprofile',
		response_type: 'code',
		acr_values: 'Level4',
	},
};

export const ansattilbyder = {
	id: 'ansatt',
	realm: 'employees',
	clientIdNokkel: 'clientId',
	innstillinger: {
		scope: 'openid svvprofile',
		response_type: 'id_token token',
		acr_values: null,
	},
};

const innloggingsadresser = [
	{
		env: 'utv',
		url: 'https://www.utv.vegvesen.no:443/openam/oauth2',
	},
	{
		env: 'test',
		url: 'https://www.test.vegvesen.no:443/openam/oauth2',
	},
	{
		env: 'prod',
		url: 'https://www.vegvesen.no:443/openam/oauth2',
	},
];

const lagringsnokkel =
	'no.vegvesen.veg.arbeidsvarsling.brukersesjon.innstillinger';

var brukersesjon = null;

function getInnstillinger() {
	return JSON.parse(sessionStorage.getItem(lagringsnokkel) || '{}');
}

function setInnstillinger(innstillinger) {
	sessionStorage.setItem(lagringsnokkel, JSON.stringify(innstillinger));
}

function mottaInnlogging() {
	var nokler = window.location.hash
		.substring(1)
		.split('&')
		.map((arg) => arg.split('=')[0]);
	if (nokler.includes('access_token')) {
		brukersesjon = new UserManager(getInnstillinger());
		brukersesjon
			.signinRedirectCallback()
			.then(
				() =>
					(window.location.href = window.location.href.split('#')[0])
			)
			.catch((err) => {
				throw err;
			});
		return true;
	}
}

function getBrukersesjon() {
	var innstillinger = getInnstillinger();
	if (!brukersesjon && Object.keys(innstillinger).length > 0) {
		brukersesjon = new UserManager(innstillinger);
	}
	return brukersesjon;
}

export function velgInnloggingstilbyder(tilbyder, oidc) {
	beregnInnstillinger(tilbyder, oidc[tilbyder.clientIdNokkel]);
	getBrukersesjon()
		.signinRedirect()
		.catch((err) => console.error(err));
}

function beregnInnstillinger(tilbyder, clientId) {
	var miljo = installasjon.getMiljo();
	var openamurl = innloggingsadresser.find((adr) => adr.env === miljo).url;
	var innstillinger = tilbyder.innstillinger;
	innstillinger.authority = openamurl + '/' + tilbyder.realm;
	innstillinger.client_id = clientId;
	innstillinger.login_hint = true;
	innstillinger.loadUserInfo = false;
	innstillinger.redirect_uri = window.location + '';
	innstillinger.redirect_uri = innstillinger.redirect_uri.split('#')[0];
	innstillinger.post_logout_redirect_uri = innstillinger.redirect_uri;
	setInnstillinger(innstillinger);
}

export function hentBruker() {
	try {
		try {
			if (!sessionStorage) {
				throw null;
			}
		} catch (e) {
			throw new Feil(
				'Innlogging krever at sessionStorage er aktivert.'
			).med('unntak', e);
		}
		Log.level = Log.ERROR;
		Log.logger = {
			debug: () => undefined,
			info: () => undefined,
			warn: () => undefined,
			error: (e) => {
				return Promise.reject(
					new Feil('Feil fra oidc-client').med('unntak', e)
				);
			},
		};
		if (mottaInnlogging()) {
			return new Promise(() => undefined);
		}
		var handterer = getBrukersesjon();
		if (!handterer) {
			return Promise.resolve(undefined);
		}
		return handterer.getUser().then((bruker) => {
			if (bruker && bruker.expires_at) {
				var natid = new Date().getTime();
				var utlopstid = bruker.expires_at * 1000;
				if (utlopstid <= natid) {
					return undefined;
				}
			}
			return bruker;
		});
	} catch (e) {
		return Promise.reject(
			new Feil('Feil ved autorisering').med('unntak', e)
		);
	}
}
